'use strict';

angular.module('pulianiBookStoreApp')
  .directive('catTree', function () {
    return {
      templateUrl: 'components/directives/catTree/catTree.html',
      restrict: 'E',
       scope: {
         cat: '=',
		 filter: '='
      },
      link: function (scope, elm, attrs)
      {
          scope.removeDollarSign = function (name) {
            var new_name = name.replace(/\$/g, ",");
            return new_name;
          };
      }
    };
  });
